document.addEventListener("DOMContentLoaded", (event) => {
  const modalOpeners = document.querySelectorAll(".bfcm-bundle-opener");
  if(modalOpeners.length > 0){
    modalOpeners.forEach((el) => {
      el.addEventListener("click",(evt)=>{
        document.querySelectorAll(".custom-modal__centered.active").forEach(el => el.classList.remove("active"));
        const current_modal = document.querySelector(`.custom-modal__centered[data-id="${el.dataset.id}"]`);
        if(current_modal){
          current_modal.classList.add("active");
          document.body.classList.add("bfcm-overflow-hidden");
        }
      });
    });
  }
  const modalClosner = document.querySelectorAll(".custom-modal__centered .modal-close");
  if(modalClosner.length > 0){
    modalClosner.forEach((el) => {
      el.addEventListener("click",(evt)=>{
         if(el.closest('.custom-modal__centered.active')){
            el.closest('.custom-modal__centered.active').classList.remove("active");
            document.body.classList.remove("bfcm-overflow-hidden");
        }
      });
    });
  }
  const cartNotWrapper = document.querySelector("#CartDrawer .cart-note-wrapper");
  if(cartNotWrapper){
    cartNotWrapper.querySelector("label").addEventListener("click",(evt) => {
      if(cartNotWrapper.querySelector(".cart-notes").classList.contains('hidden')){
        cartNotWrapper.querySelector(".cart-notes").classList.remove("hidden");
      }else{
        cartNotWrapper.querySelector(".cart-notes").classList.add("hidden");
      }
    });
  }
  const customAtcs = document.querySelectorAll(".custom-atc");
  if(customAtcs.length > 0){
    customAtcs.forEach((button) => {
      button.addEventListener("click",async (evt) => {
        evt.preventDefault();
        const vid = button.dataset.id;
        button.setAttribute('disabled', true);
        button.classList.add('btn--loading');
        let items = [];
        items.push({
              id: vid,
              quantity: 1
          });
          
          const body = JSON.stringify({
              items: items
          });
          
          try {
              const response = await fetch(`/cart/add.js`, { 
                  method: 'POST',
                  body: body,
                  credentials: 'same-origin',
                  headers: {
                      'Content-Type': 'application/json',
                  }
              });
              const data = await response.json();
              
              if (data.status === 422) {
                  
              } else {
                  document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                      detail: {
                          product: data,
                          addToCartBtn: button
                      }
                  }));
              }
          } catch (e) {
              console.error(e);
          } finally {
              button.classList.remove('btn--loading');
              button.removeAttribute('disabled');
          }
      });
    });
  }
});

if (!customElements.get('custom-remove-button')) {
  customElements.define('custom-remove-button', class CustomRemoveButton extends HTMLElement {
    constructor() {
      super();
      this.button = this.querySelector("button");
      this.miniCart = document.querySelector('mini-cart');
      
      this.initEventListeners();
    }
    initEventListeners(){
        this.button.addEventListener("click",this.removeItem.bind(this));
    }
   
    removeItem(evt){
        evt.preventDefault();
        const isMain = this.dataset.ismain;
        const bundleid = this.dataset.bundleid;
        const itemKey = this.dataset.key;
        const itemSelector = `div.cart__item[data-bundleid="${bundleid}"][data-ismain="0"]`;
        this.button.setAttribute('disabled', true);
        this.button.classList.add('loading');
        let items = [];
        document.querySelectorAll(itemSelector).forEach((el) => {
          items.push({
            id: `${el.dataset.key}`,
            quantity:0
          });
        });
       items.push({
          id: `${itemKey}`,
          quantity:0
        });
        let updates = items.reduce((acc, { id, quantity }) => {
            acc[id] = quantity;
            return acc;
        }, {});
        const body = JSON.stringify({
            updates,
        });
        
        fetch('/cart/update.js',{
          method: 'POST',
          body: body,
          credentials: 'same-origin',
          headers: {
              'Content-Type': 'application/json',
          }
        })
        .then((response) => {
            return response.json();
        })
        .then((cart) => {
            if (document.body.classList.contains('template-cart')) {
              window.location.reload(true);
            }
            document.dispatchEvent(new CustomEvent('cart:customupdate', {
              detail: {
                cart: cart
              }
            }));
      })
      .catch(() => {
        
      })
        .finally(() => {
            this.button.classList.remove('loading');
            this.button.removeAttribute('disabled');
        });
    }
  });
}
class CustomCartMainUpsell extends HTMLElement {
    constructor() {
      super();
      this.buttons = this.querySelectorAll(".btn");
      this.variantSelectors = this.querySelectorAll("select.variant-selector-for-upsell");
      this.swiperElement = this.querySelector('.custom-main-upsell-swiper-slider');
      this.mainId = this.dataset.pid;
      
    }
    async init(){
      if(this.querySelectorAll(".custom-main-upsell-slide").length > 0){
        this.loadSwiperSlider();
      }else{
        this.style.display = "none";
      }
      
    }
    
    connectedCallback() {
      this.init();
      this.setupEventListeners();
    }
    
    disconnectedCallback() {
    }
    setupEventListeners() {
      //this.buttons.addEventListener("click",this.upsellAddToCart.bind(this));
      this.buttons.forEach((el) => {
        el.addEventListener("click",this.upsellAddToCart.bind(this));
      });
      this.variantSelectors.forEach((el) => {
        el.addEventListener("change",this.onVariantChange.bind(this));
      })
    }
    onVariantChange(evt){
      const mainElement = evt.target.closest(".custom-main-upsell-slide-buttons");
     const button = mainElement.querySelector("button");
     if(button){
      button.dataset.vid = evt.target.value;
     }
      
    }
    loadSwiperSlider(){
      this.paginationElement = this.querySelector('.swiper-pagination');
      const swiper = new Swiper(this.swiperElement, {
        slidesPerView: 1,
        spaceBetween: 10,
        centeredSlides: false,
        navigation: {
          nextEl:this.querySelector( ".swiper-button-next"),
          prevEl: this.querySelector(".swiper-button-prev"),
        },
      });
    }
    async upsellAddToCart(evt){
      evt.preventDefault();
      const button = evt.target;
      const mainId = evt.target.dataset.vid;
      let items = [
          {
            id:mainId,
            quantity:1,
          }
      ];
      button.setAttribute('disabled', true);
        button.classList.add('btn--loading');
      const body = JSON.stringify({
            items: items
        });
      try {
          const response = await fetch(`/cart/add.js`, { 
              method: 'POST',
              body: body,
              credentials: 'same-origin',
              headers: {
                  'Content-Type': 'application/json',
              }
          });
          const data = await response.json();
          
          if (data.status === 422) {
              
          } else {
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                  detail: {
                      product: data,
                      addToCartBtn: button
                  }
              }));
          }
      } catch (e) {
          console.error(e);
      } finally {
          
          button.classList.remove('btn--loading');
          button.removeAttribute('disabled');
      }
    }
    
}

// Register the custom element
customElements.define('custom-cart-main-upsell', CustomCartMainUpsell);

class ShippingProgressBar extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    
    // Default properties
    this._threshold1 = 5500;
    this._threshold2 = 7500;
    this._current = 0;
    this._currency = '$';
    this._threshold1Message = 'Plus que __AMOUNT__ pour profiter de la __REWARD__';
    this._threshold2Message = 'Plus que __AMOUNT__ pour profiter de la __REWARD__';
    this._successMessage = 'Félicitations ! Vous bénéficiez de tous les avantages !';
    this._reward1 = 'livraison offerte';
    this._reward2 = 'Bracelet Le Vent à la Française';
    this._progressColor = '#006B54';
    this._backgroundColor = '#E5E5E5';
    this._threshold2Product = "";
    this._giftProductAdded = false;
    this._isProcessing = false;
  }

  static get observedAttributes() {
    return [
      'threshold1', 'threshold2', 'current', 'currency',
      'threshold1-message', 'threshold2-message', 'success-message',
      'reward1', 'reward2', 'progress-color', 'background-color', 'threshold2Product'
    ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue === newValue) return;
    
    const attrMap = {
      'threshold1': '_threshold1',
      'threshold2': '_threshold2',
      'current': '_current',
      'currency': '_currency',
      'threshold1-message': '_threshold1Message',
      'threshold2-message': '_threshold2Message',
      'success-message': '_successMessage',
      'reward1': '_reward1',
      'reward2': '_reward2',
      'progress-color': '_progressColor',
      'background-color': '_backgroundColor',
      'threshold2Product': '_threshold2Product'
    };
    
    if (attrMap[name]) {
      const prevCurrent = this._current;
      
      if (name === 'threshold1' || name === 'threshold2' || name === 'current') {
        this[attrMap[name]] = parseInt(newValue, 10) || 0;
      } else {
        this[attrMap[name]] = newValue;
      }
      
      // Check if we need to add/remove gift product when current amount changes
      if (name === 'current' && this._threshold2Product && this._threshold2 > 0) {
        this.handleGiftProduct(prevCurrent);
      }
      
      this.render();
    }
  }

  connectedCallback() {
    const attrs = {
      'threshold1': '_threshold1',
      'threshold2': '_threshold2',
      'current': '_current',
      'currency': '_currency',
      'threshold1-message': '_threshold1Message',
      'threshold2-message': '_threshold2Message',
      'success-message': '_successMessage',
      'reward1': '_reward1',
      'reward2': '_reward2',
      'progress-color': '_progressColor',
      'background-color': '_backgroundColor',
      'threshold2Product': '_threshold2Product'
    };
    
    Object.keys(attrs).forEach(attr => {
      if (this.hasAttribute(attr)) {
        const value = this.getAttribute(attr);
        if (attr === 'threshold1' || attr === 'threshold2' || attr === 'current') {
          this[attrs[attr]] = parseInt(value, 10) || 0;
        } else {
          this[attrs[attr]] = value;
        }
      }
    });
    
    console.log('Component connected. Threshold2:', this._threshold2, 'Product:', this._threshold2Product);
    
    // Check initial state for gift product
    if (this._threshold2Product) {
      if (this._threshold2 > 0) {
        console.log('Threshold2 is active, checking gift product in cart');
        this.checkGiftProductInCart();
      } else {
        console.log('Threshold2 is 0, removing any existing gift product');
        this.removeGiftProductIfExists();
      }
    }
    
    this.render();
  }

  async handleGiftProduct(prevCurrent) {
    if (this._isProcessing || this._threshold2 <= 0) return;
    
    const wasAboveThreshold = prevCurrent >= this._threshold2;
    const isAboveThreshold = this._current >= this._threshold2;
    
    // Crossed threshold upward - add gift
    if (!wasAboveThreshold && isAboveThreshold) {
      await this.addGiftProduct();
    }
    // Crossed threshold downward - remove gift
    else if (wasAboveThreshold && !isAboveThreshold) {
      await this.removeGiftProduct();
    }
  }

  async checkGiftProductInCart() {
    if (this._threshold2 <= 0) {
      console.log('checkGiftProductInCart: threshold2 is 0, skipping');
      return;
    }
    
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const giftItem = cart.items.find(item => 
        item.variant_id === parseInt(this._threshold2Product) ||
        item.id === parseInt(this._threshold2Product)
      );
      
      this._giftProductAdded = !!giftItem;
      console.log('Gift product in cart:', this._giftProductAdded);
      
      // If gift is in cart but threshold not met, remove it
      if (this._giftProductAdded && this._current < this._threshold2) {
        console.log('Gift in cart but threshold not met, removing');
        await this.removeGiftProduct();
      }
      // If gift is not in cart but threshold is met, add it
      else if (!this._giftProductAdded && this._current >= this._threshold2) {
        console.log('Gift not in cart but threshold met, adding');
        await this.addGiftProduct();
      }
    } catch (error) {
      console.error('Error checking gift product in cart:', error);
    }
  }

  async removeGiftProductIfExists() {
    if (this._isProcessing || !this._threshold2Product) {
      console.log('removeGiftProductIfExists: skipping (isProcessing or no product)');
      return;
    }
    
    this._isProcessing = true;
    console.log('removeGiftProductIfExists: Starting removal process');
    
    try {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      console.log('Current cart items:', cart.items.length);
      
      // Find the gift item - check both variant_id and properties
      const giftItemIndex = cart.items.findIndex(item => {
        const isGiftProduct = item.variant_id === parseInt(this._threshold2Product) || 
                             item.id === parseInt(this._threshold2Product);
        const hasGiftProperty = item.properties && (
          item.properties._gift === '1' || 
          item.properties._gift === 1 || 
          item.properties._gift === 'true' ||
          item.properties._gift === true
        );
        
        console.log('Checking item:', item.variant_id, 'isGift:', isGiftProduct, 'hasProperty:', hasGiftProperty);
        
        return isGiftProduct || hasGiftProperty;
      });
      
      console.log('Gift item found at index:', giftItemIndex);
      
      if (giftItemIndex !== -1) {
        const updates = {
          line: giftItemIndex + 1, // Shopify uses 1-based indexing
          quantity: 0
        };
        
        console.log('Removing gift product, line:', updates.line);
        
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates)
        });
        
        if (response.ok) {
          this._giftProductAdded = false;
          const updatedCart = await response.json();
          console.log('Gift product removed successfully. New cart items:', updatedCart.items.length);
          
          if (document.body.classList.contains('template-cart')) {
            window.location.reload(true);
          }
          
          document.dispatchEvent(new CustomEvent('cart:customupdate', {
            detail: { cart: updatedCart }
          }));
        } else {
          console.error('Failed to remove gift product:', response.status, await response.text());
        }
      } else {
        console.log('No gift product found in cart');
      }
    } catch (error) {
      console.error('Error removing gift product:', error);
    } finally {
      this._isProcessing = false;
    }
  }

  async addGiftProduct() {
    // Don't add gift if threshold2 is 0 or not set
    if (this._isProcessing || this._giftProductAdded || !this._threshold2Product || this._threshold2 <= 0) {
      console.log('Gift product not added:', {
        isProcessing: this._isProcessing,
        alreadyAdded: this._giftProductAdded,
        hasProduct: !!this._threshold2Product,
        threshold2: this._threshold2
      });
      return;
    }
    
    this._isProcessing = true;
    console.log('Adding gift product:', this._threshold2Product);
    
    try {
      const formData = {
        items: [{
          id: parseInt(this._threshold2Product),
          quantity: 1,
          properties: {
            '_gift': '1',
            '_gift_threshold': this._threshold2
          }
        }]
      };
      
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      
      if (response.ok) {
        this._giftProductAdded = true;
        
        // Trigger cart update event for theme compatibility
        const cart = await response.json();
        console.log('Gift product added successfully');
        
        if (document.body.classList.contains('template-cart')) {
          window.location.reload(true);
        }
        
        document.dispatchEvent(new CustomEvent('cart:customupdate', {
          detail: {
            cart: cart
          }
        }));
      } else {
        console.error('Failed to add gift product:', response.status, await response.text());
      }
    } catch (error) {
      console.error('Error adding gift product:', error);
    } finally {
      this._isProcessing = false;
    }
  }

  async removeGiftProduct() {
    if (this._isProcessing || !this._giftProductAdded || !this._threshold2Product) return;
    
    this._isProcessing = true;
    console.log('removeGiftProduct: Removing gift due to threshold not met');
    
    try {
      // First, get the cart to find the line item
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      const giftItemIndex = cart.items.findIndex(item => {
        const isGiftProduct = item.variant_id === parseInt(this._threshold2Product) || 
                             item.id === parseInt(this._threshold2Product);
        const hasGiftProperty = item.properties && (
          item.properties._gift === '1' || 
          item.properties._gift === 1 || 
          item.properties._gift === 'true' ||
          item.properties._gift === true
        );
        return isGiftProduct || hasGiftProperty;
      });
      
      if (giftItemIndex !== -1) {
        const updates = {
          line: giftItemIndex + 1, // Shopify uses 1-based indexing
          quantity: 0
        };
        
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updates)
        });
        
        if (response.ok) {
          this._giftProductAdded = false;
          
          // Trigger cart update event
          const cart = await response.json();
          console.log('Gift product removed successfully');
          
          if (document.body.classList.contains('template-cart')) {
            window.location.reload(true);
          }
          
          document.dispatchEvent(new CustomEvent('cart:customupdate', {
            detail: {
              cart: cart
            }
          }));
        } else {
          console.error('Failed to remove gift product:', await response.text());
        }
      }
    } catch (error) {
      console.error('Error removing gift product:', error);
    } finally {
      this._isProcessing = false;
    }
  }

  formatCurrency(cents) {
    if (typeof theme !== 'undefined' && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return this._currency + (cents / 100).toFixed(2);
  }

  render() {
    let remainingAmount, progressMessage, progressPercentage;
    const hasSecondThreshold = this._threshold2 > 0;
    const isThreshold1Complete = this._current >= this._threshold1;
    const isThreshold2Complete = hasSecondThreshold && this._current >= this._threshold2;
    
    if (!isThreshold1Complete) {
      remainingAmount = this._threshold1 - this._current;
      // If no second threshold, progress goes from 0 to 100% for threshold1
      progressPercentage = hasSecondThreshold 
        ? (this._current / this._threshold1) * 50 
        : (this._current / this._threshold1) * 100;
      progressMessage = this._threshold1Message
        .replace('__AMOUNT__', `<span class="amount">${this.formatCurrency(remainingAmount)}</span>`)
        .replace('__REWARD__', `<strong>${this._reward1}</strong>`);
    } else if (hasSecondThreshold && !isThreshold2Complete) {
      remainingAmount = this._threshold2 - this._current;
      const progressBeyondFirst = this._current - this._threshold1;
      const rangeBetweenThresholds = this._threshold2 - this._threshold1;
      progressPercentage = 50 + (progressBeyondFirst / rangeBetweenThresholds) * 50;
      progressMessage = this._threshold2Message
        .replace('__AMOUNT__', `<span class="amount">${this.formatCurrency(remainingAmount)}</span>`)
        .replace('__REWARD__', `<strong>${this._reward2}</strong>`);
    } else {
      progressPercentage = 100;
      progressMessage = `<span class="complete">${this._successMessage}</span>`;
    }
    
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          width: 100%;
        }
        
        .container {
          padding: 0;
        }
        
        .message {
          margin-bottom: 12px;
          font-size: 13px;
          line-height: 1.5;
          color: #000;
        }
        
        .amount {
          font-weight: 700;
        }
        
        .complete {
          font-weight: 600;
          color: #000;
        }
        
        .bar-wrapper {
          position: relative;
          padding-bottom: 35px;
        }
        
        .bar {
          height: 6px;
          background: ${this._backgroundColor};
          border-radius: 10px;
          overflow: hidden;
        }
        
        .fill {
          height: 100%;
          width: ${Math.min(100, Math.max(0, progressPercentage))}%;
          background: ${this._progressColor};
          border-radius: 10px;
          transition: width 0.4s ease;
        }
        
        .icon {
          position: absolute;
          top: -11px;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: white;
          border: 3px solid ${this._backgroundColor};
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          transform: translateX(-50%);
        }
        
        .icon.done {
          background: ${this._progressColor};
          border-color: ${this._progressColor};
          color: white;
          font-weight: bold;
        }
        
        .icon.hidden {
          display: none;
        }
        
        .icon-1 { left: ${hasSecondThreshold ? '50%' : '100%'}; }
        .icon-2 { right: 0; }
        
        .label {
          position: absolute;
          top: 25px;
          font-size: 10px;
          line-height: 1.3;
          color: #000;
          text-align: center;
          max-width: 90px;
        }
        
        .label.done {
          color: #000;
          font-weight: 600;
        }
        
        .label.hidden {
          display: none;
        }
        
        .label-1 {
          left: ${hasSecondThreshold ? '50%' : '100%'};
          transform: translateX(-50%);
        }
        
        .label-2 {
          right: 0;
          /*transform: translateX(50%);*/
        }
      </style>
      
      <div class="container">
        <div class="message">${progressMessage}</div>
        
        <div class="bar-wrapper">
          <div class="bar">
            <div class="fill"></div>
            
            <div class="icon icon-1 ${isThreshold1Complete ? 'done' : ''}">
              ${isThreshold1Complete ? '✓' : '🎁'}
            </div>
            
            <div class="icon icon-2 ${isThreshold2Complete ? 'done' : ''} ${!hasSecondThreshold ? 'hidden' : ''}">
              ${isThreshold2Complete ? '✓' : '🎁'}
            </div>
          </div>
          
          <div class="label label-1 ${isThreshold1Complete ? 'done' : ''}">
            ${this._reward1}
          </div>
          
          <div class="label label-2 ${isThreshold2Complete ? 'done' : ''} ${!hasSecondThreshold ? 'hidden' : ''}">
            ${this._reward2}
          </div>
        </div>
      </div>
    `;
  }
}


customElements.define('shipping-progress-bar', ShippingProgressBar);